import React, { useState, useEffect, useCallback, useContext } from 'react';
import Template from './template';
import * as S from './style';
import {
  Label,
  ChkBox,
  Input,
  SelectBox,
  FormItem,
  ContentsContainer,
  BtnContainer,
  BtnNext,
} from 'components';
import { useApiRequest, useAddress } from 'hooks';
import { SignupState, SignupAction } from 'stores/PartnerSignUpStore';
import { defaultState } from 'stores/PartnerSignUpStore/reducer';
import { apiGetPartnerSurveyContents, apiPartnerSignUp } from 'api/ZimssaAPI';
import { TITLE_PARTNER_SIGNUP, BUTTON_COMPLETE } from 'commons/ZimssaString';
import { useHistory } from 'react-router-dom';
import { SIGNUP, PARTNER_COMPLETED } from 'router/PageUrl';
import Radio from 'components/atoms/Radio';
import { showModal } from '../../commons/utils/showModal';

function PartnerSurveyView(): React.ReactElement {
  const history = useHistory();
  const { province, city, getCityCallback } = useAddress();
  const partnerSignUpState = useContext(SignupState);
  const dispatcher = useContext(SignupAction);
  const [surveyList, setSurveyList] =
    useState<IPartnerSurveyProps>(defaultProps);
  const [surveyForm, setSurveyForm] = useState<
    Array<{
      masterIdx: number;
      contentsIdx: number;
      etcContents: string;
    }>
  >([]);
  const [fetchResult, fetchGetSurveyContents] = useApiRequest<any>(
    apiGetPartnerSurveyContents
  );
  const [selectedSmallMove, setSelectedSmallMove] = useState<boolean>(false);
  const [selectedFamilyMove, setSelectedFamilyMove] = useState<boolean>(false);
  const [selectedClean, setSelectedClean] = useState<boolean>(false);

  useEffect(() => {
    if (!!!selectedFamilyMove && !!!selectedSmallMove) {
      setSurveyForm(surveyForm.filter((item) => item.masterIdx !== 5));
    }
  }, [selectedSmallMove, selectedFamilyMove]);

  useEffect(() => {
    if (!!!selectedClean) {
      setSurveyForm(surveyForm.filter((item) => item.masterIdx !== 7));
    }
  }, [selectedClean]);

  useEffect(() => {
    const partnerSignUpStates: { [key: string]: any } = partnerSignUpState;
    if (
      Object.keys(partnerSignUpStates).some(
        (key) => partnerSignUpStates[key] === ''
      )
    ) {
      alert('파트너 정보를 다시 입력 바랍니다.');
      history.push(SIGNUP.path);
    }
  }, []);

  useEffect(() => {
    const { result, data } = fetchResult;
    if (result === 'success' && data) {
      const responseData: IPartnerSurveyProps = data;
      setSurveyList(responseData);
    }
  }, [fetchResult]);

  useEffect(() => {
    fetchGetSurveyContents({
      type: 'REQUEST',
    });
  }, [fetchGetSurveyContents]);

  const handleSubmit = async () => {
    const confirmed = await showModal({
      title: '파트너 가입을 진행 하시겠습니까?',
    });
    if (!confirmed) return;

    apiPartnerSignUp({
      name: partnerSignUpState.name,
      phone: partnerSignUpState.phone,
      authCode: partnerSignUpState.authCode,
      birthday: partnerSignUpState.birthday,
      partnerSurvey: surveyForm,
    })
      .then((response) => {
        const { result, message } = response;
        if (result === 'success') {
          dispatcher({
            type: 'SET_STATE',
            value: defaultState,
          });
          history.push(PARTNER_COMPLETED.url);
        } else {
          if (message) alert(message);
        }
      })
      .catch((error) => {});
  };

  return (
    <Template>
      <S.TitleWrapper>
        <Label
          contents={TITLE_PARTNER_SIGNUP}
          color={'gray_opacity_800'}
          fontStyle={'h3_bold'}
        />
      </S.TitleWrapper>
      <ContentsContainer title={'파트너 가입 설문'}>
        {surveyList.surveyMasterList.map(
          (mst) =>
            /**
             * mst.name '사용 중인 이사 서비스', '사용 중인 청소 서비스'는 지원서비스가 선택되었을 때만 보여지도록
             */
            (!['사용 중인 이사 서비스', '사용 중인 청소 서비스'].includes(
              mst.name
            ) ||
              (mst.idx === 5 &&
                mst.name === '사용 중인 이사 서비스' &&
                (selectedFamilyMove || selectedSmallMove)) ||
              (mst.idx === 7 &&
                mst.name === '사용 중인 청소 서비스' &&
                selectedClean)) && (
              <FormItem
                itemSpace={8}
                key={mst.idx}
                label={mst.name}
                itemType={mst.type === 'check' ? 'SURVEY' : undefined}
                optionalChildren={
                  surveyForm.some(
                    (item) =>
                      item.contentsIdx ===
                      surveyList.surveyContentsList.find(
                        (item) => item.masterIdx === mst.idx && item.isEtc
                      )?.idx
                  ) ? (
                    <Input
                      inputName={'txtEtcContents'}
                      placeholder={'기타 내용을 입력 해주세요.'}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const { value } = e.target;
                        const etcContentsIdx =
                          surveyList.surveyContentsList.find(
                            (item) => item.masterIdx === mst.idx && item.isEtc
                          )?.idx || 0;
                        setSurveyForm([
                          ...surveyForm.filter(
                            (item) => item.contentsIdx !== etcContentsIdx
                          ),
                          {
                            masterIdx: mst.idx,
                            contentsIdx: etcContentsIdx,
                            etcContents: value,
                          },
                        ]);
                      }}
                    />
                  ) : null
                }
              >
                {surveyList.surveyContentsList
                  .filter((contents) => contents.masterIdx === mst.idx)
                  .map((contents, index) => {
                    if (mst.type === 'location') {
                      if (contents.contents.indexOf('시,도') > -1) {
                        return (
                          <SelectBox
                            key={contents.idx}
                            inputName={'location1'}
                            onChangeHandler={(type: any, value: string) => {
                              getCityCallback(value);
                              setSurveyForm([
                                ...surveyForm.filter(
                                  (item) => item.contentsIdx !== contents.idx
                                ),
                                {
                                  masterIdx: contents.masterIdx,
                                  contentsIdx: contents.idx,
                                  etcContents: value,
                                },
                              ]);
                            }}
                          >
                            {province}
                          </SelectBox>
                        );
                      } else {
                        return (
                          <SelectBox
                            key={contents.idx}
                            inputName={'location2'}
                            onChangeHandler={(type: any, value: string) => {
                              setSurveyForm([
                                ...surveyForm.filter(
                                  (item) => item.contentsIdx !== contents.idx
                                ),
                                {
                                  masterIdx: contents.masterIdx,
                                  contentsIdx: contents.idx,
                                  etcContents: value,
                                },
                              ]);
                            }}
                          >
                            {city}
                          </SelectBox>
                        );
                      }
                    } else if (mst.type === 'check') {
                      return (
                        <S.GridWrapper
                          key={contents.idx}
                          isLast={
                            surveyList.surveyContentsList.length === index &&
                            (index + 1) % 2 !== 0
                              ? true
                              : false
                          }
                        >
                          <ChkBox
                            title={contents.contents}
                            checked={surveyForm.some(
                              (item) => item.contentsIdx === contents.idx
                            )}
                            onClick={(
                              e: React.MouseEvent<HTMLDivElement, MouseEvent>,
                              value?: any,
                              checked?: boolean
                            ) => {
                              if (contents.masterIdx === 2) {
                                switch (contents.contents) {
                                  case '소형이사':
                                    checked
                                      ? setSelectedSmallMove(false)
                                      : setSelectedSmallMove(true);
                                    break;
                                  case '가정이사':
                                    checked
                                      ? setSelectedFamilyMove(false)
                                      : setSelectedFamilyMove(true);
                                    break;

                                  case '청소':
                                    checked
                                      ? setSelectedClean(false)
                                      : setSelectedClean(true);
                                    break;
                                  default:
                                }
                              }
                              if (!checked) {
                                // 없음 선택일때 기존꺼 체크 해제
                                if (contents.contents === '없음') {
                                  setSurveyForm([
                                    ...surveyForm.filter(
                                      (item) =>
                                        item.masterIdx !== contents.masterIdx
                                    ),
                                    {
                                      masterIdx: contents.masterIdx,
                                      contentsIdx: contents.idx,
                                      etcContents: contents.contents,
                                    },
                                  ]);
                                } else {
                                  // 없음이 없을 경우 없음을 체크 해제 한 후 진행
                                  setSurveyForm([
                                    ...surveyForm.filter(
                                      (item) =>
                                        item.masterIdx !== contents.masterIdx
                                    ),
                                    ...surveyForm
                                      .filter(
                                        (item) =>
                                          item.masterIdx ===
                                            contents.masterIdx &&
                                          item.etcContents !== '없음'
                                      )
                                      .concat({
                                        masterIdx: contents.masterIdx,
                                        contentsIdx: contents.idx,
                                        etcContents: contents.contents,
                                      }),
                                  ]);
                                }
                              } else {
                                // 기본진행
                                setSurveyForm(
                                  surveyForm.filter(
                                    (item) => item.contentsIdx !== contents.idx
                                  )
                                );
                              }
                            }}
                          />
                        </S.GridWrapper>
                      );
                    } else {
                      return (
                        <S.CheckBoxWrapper key={contents.idx}>
                          <S.RadioWrapper>
                            <Radio
                              id={contents.contents}
                              // boxType={'RADIO'}
                              title={contents.contents}
                              checked={surveyForm.some(
                                (item) => item.contentsIdx === contents.idx
                              )}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>,
                                value?: any,
                                checked?: boolean
                              ) => {
                                // 라디오버튼 진행.
                                setSurveyForm([
                                  ...surveyForm.filter(
                                    (item) =>
                                      item.masterIdx !== contents.masterIdx
                                  ),
                                  {
                                    masterIdx: contents.masterIdx,
                                    contentsIdx: contents.idx,
                                    etcContents: contents.contents,
                                  },
                                ]);
                              }}
                            />
                          </S.RadioWrapper>
                          <S.CheckLabelWrapper>
                            <Label
                              fontStyle={'body2'}
                              htmlFor={contents.contents}
                              color={'gray_opacity_800'}
                              contents={contents.contents}
                            />
                          </S.CheckLabelWrapper>
                        </S.CheckBoxWrapper>
                      );
                    }
                  })}
              </FormItem>
            )
        )}
        <BtnContainer>
          <BtnNext
            {...{
              contents: BUTTON_COMPLETE,
              isActive:
                surveyList.surveyMasterList.length -
                  Number(!!!selectedSmallMove && !!!selectedFamilyMove) -
                  Number(!!!selectedClean) ===
                Array.from(new Set(surveyForm.map((item) => item.masterIdx)))
                  .length,
              onClick: handleSubmit,
            }}
          />
        </BtnContainer>
      </ContentsContainer>
    </Template>
  );
}

export default PartnerSurveyView;

interface IPartnerSurveyProps {
  surveyMasterList: Array<{ idx: number; name: string; type: string }>;
  surveyContentsList: Array<{
    idx: number;
    masterIdx: number;
    contents: string;
    isEtc: boolean;
  }>;
}

const defaultProps: IPartnerSurveyProps = {
  surveyMasterList: [],
  surveyContentsList: [],
};

interface IPartnerSurveyForm {
  partnerSurvey: Array<{
    masterIdx: number;
    contentsIdx: number;
    etcContents: string;
  }>;
}
